import { EntityId } from "@jackfruit/common"
import { useEffect } from "react"
import { useCanonical } from "./useCanonical"

export const useForceCanonicalForPage = (
  pageId: EntityId,
  canonical: string
) => {
  const [_, setCanonical] = useCanonical(pageId)

  useEffect(() => {
    if (canonical) {
      setCanonical(canonical)
    }
  }, [canonical, setCanonical])
}
